import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { RegisterState } from './states'

const register: Module<RegisterState, State> = {
  state: new RegisterState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default register
